import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { Box, Divider, FormControlLabel, IconButton, List, Popover, Stack, Switch, useTheme } from '@mui/material'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  WaterSystemsActions,
  WaterSystemType,
} from '../../../store/waterSystems'
import { GlobeIcon, LockIcon, MenuIcon } from '../../icons'
import { ListItem } from '../../Sidebar/subComponent'
import { AppActions } from '../../../store/app'
import { MapActions, MapSelector } from '../../../store/Map'

const ZoomControls = ({ onZoomIn, onZoomOut }: { onZoomIn: () => void; onZoomOut: () => void }) => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [selectedIndex, setSelectedIndex] = useState(0)
  const isMenuOpen = Boolean(anchorEl)
  const includeTransient = useSelector(MapSelector.getIncludeTransient)
  const handleMenuClick = (event: React.MouseEvent) => {
    setAnchorEl(event.currentTarget as HTMLElement)
  }
  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleListItemClick = async (index: number, type: WaterSystemType) => {

    setSelectedIndex(index)
    dispatch(AppActions.setMapDataDrawerOpen(false))
    dispatch(WaterSystemsActions.setSelectedSystemType(type))
    handleMenuClose()
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '20px',
        right: '20px',
        display: 'flex',
        flexDirection: 'row',
        gap: 1,
        zIndex: 1,
      }}
    >
{/*      {waterSystemType === WaterSystemType.WELL && (

      )}*/}
      <Stack gap={1}>
        <Box
          sx={{
            background: 'white',
            p: 1,
            borderRadius: '12px',
            display: 'flex',
            justifyContent: 'center',
            boxShadow: theme.shadows[3],
          }}
        >
          <MenuIcon sx={{ color: 'transparent', cursor: 'pointer' }} onClick={handleMenuClick} />
        </Box>
        <Stack
          gap={1}
          sx={{
            background: 'white',
            borderRadius: '12px',
            p: 0.5,
            boxShadow: theme.shadows[3],
          }}
        >
          <IconButton
            onClick={onZoomIn}
            sx={{
              p: '4px',
            }}
          >
            <AddIcon />
          </IconButton>
          <Divider />
          <IconButton
            onClick={onZoomOut}
            sx={{
              p: '4px',
            }}
          >
            <RemoveIcon />
          </IconButton>
        </Stack>
      </Stack>

      <Popover
        open={isMenuOpen}
        anchorEl={anchorEl}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{
          mt: 2,
          '& .MuiPaper-root': {
            borderRadius: '12px !important',
            background: 'rgba(255, 255, 255, 0.9)',
          },
        }}
      >
        <Box sx={{ p: 1.5, minWidth: 229 }}>
          <List sx={{ p: 0 }}>
            <ListItem
              index={0}
              selectedIndex={selectedIndex}
              onClick={() => handleListItemClick(0, WaterSystemType.PUBLIC)}
              icon={<GlobeIcon sx={{ color: 'transparent' }} />}
              label="Public water"
            />
            <ListItem
              index={1}
              selectedIndex={selectedIndex}
              onClick={() => null}//{handleListItemClick(1, WaterSystemType.WELL)}}
              icon={<LockIcon sx={{ color: 'transparent' }} />}
              label="Well water (coming soon)"
              disabled
            />
          </List>
          <Divider sx={{ my: 1 }} />
          <FormControlLabel
            control={
              <Switch
                checked={includeTransient}
                onChange={(e) => dispatch(MapActions.setIncludeTransient(e.target.checked))}
                size="small"
              />
            }
            label="Show Transient Systems"
            sx={{ ml: 0.5 }}
          />
        </Box>
      </Popover>
    </Box>
  )
}

export default ZoomControls
